import {
  IsUUID,
  IsInt,
  IsPositive,
  Min,
  Max,
  IsBoolean,
  IsOptional
} from "class-validator";
import { Type } from "class-transformer";

import TestTest from "./test";
import TestQuestionVersion from "./question_version";

export default class TestVersion {
  @IsUUID("4")
  public readonly id!: string;

  @IsInt()
  @IsPositive()
  public version: number = 1;

  @IsInt()
  @Min(0)
  @Max(100)
  public score: number = 80;

  @IsBoolean()
  public can_reanswer: boolean = true;

  @IsOptional()
  @IsInt()
  @IsPositive()
  @Min(1)
  @Max(3)
  public reanswer_count: null | number = null;

  @Type(() => TestTest)
  public test?: TestTest;

  @Type(() => TestQuestionVersion)
  public question_versions: TestQuestionVersion[] = [];
}
